import { render } from "./MyPopUpWindow.vue?vue&type=template&id=f4a6cd04"
import script from "./MyPopUpWindow.vue?vue&type=script&lang=js"
export * from "./MyPopUpWindow.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__